module.exports = __webpack_public_path__ + "static/img/zyfwhy3.d23dd7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zyfwhy3.png
// module id = ULyQ
// module chunks = 73